/* unplugin-vue-components disabled */import script from "./LegalLatestChange.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalLatestChange.vue?vue&type=script&setup=true&lang=js"

import "./LegalLatestChange.vue?vue&type=style&index=0&id=17faf5c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17faf5c4"]])

export default __exports__